import { AgencyState } from '../../models/account/agency.state';
import { GET_AGENCY, GET_AGENCY_SUCCESS, AgencyActions } from '../../actions/account/actions-agency';

export const AGENCY_REDUCER = 'agencyReducer';

export const agencyInitState: AgencyState = {
  isLoading: true,
  name: '',
  office_code: '',
  email: '',
  phone_number: '',
  fax_number: '',
  street: '',
  city: '',
  postal_code: '',
  primary_pin: ''
};

/* eslint-disable */
export function reducersAgency(state = agencyInitState, action: AgencyActions): AgencyState {
  switch (action.type) {
    case GET_AGENCY:
      return { ...state, isLoading: true };

    case GET_AGENCY_SUCCESS:
      return { ...action.payload, isLoading: false };

    default:
      return state;
  }
}
